import React from 'react';
import { Button } from '@mui/material';

export const AppButton = ({ buttonText, onClick }) => (
  <Button onClick={onClick} fullWidth variant="outlined" sx={{ borderRadius: '0px', mt: 3 }}>
    {buttonText}
  </Button>
);
